import { CreateUserForm } from '@/modules/users/interfaces/createUserForm'
import { User } from '@/modules/users/interfaces/user'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const defaults = {
	createForm: {
		name: '',
		secondName: '',
		lastname: '',
		secondLastname: '',
		birthDate: '',
		gender: '',
		email: '',
		companyId: undefined,
		roleId: undefined,
		supervisorId: undefined,
		companyGroupId: undefined,
		departmentId: undefined,
		costCenterId: undefined,
		haveAccess: false,
	},
}

export const useUserStore = defineStore('user', () => {
	const user = ref<User>()
	const createForm = ref<CreateUserForm>({
		...defaults.createForm,
	})

	return {
		user,
		createForm,

		setUser(newUser: User) {
			user.value = newUser
		},
		setCreateFormValue<T extends keyof CreateUserForm>(
			property: T,
			value: CreateUserForm[T]
		) {
			createForm.value[property] = value
		},

		resetCreateForm() {
			createForm.value = { ...defaults.createForm }
		},
	}
})
